import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-navegacao',
  templateUrl: './navegacao.component.html',
  styleUrls: ['./navegacao.component.scss']
})

export class NavegacaoComponent implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
